import DashboardDetails from './dashboard.details';

export const DashboardStores = {
  details: DashboardDetails,
};
